import React from "react";

import {Button} from "@pg-design/button-module";
import {ConstructionHelmetIcon} from "@pg-design/icons-module";
import {useUserDevice} from "@pg-mono/user-device";

import {OfferDetailBrandButtonStyle} from "../atoms/OfferNavBar";

interface Props {
    onButtonClick: () => void;
}

export const DetailConstructionGalleryCTA = (props: Props) => {
    const {isMobile} = useUserDevice();
    return (
        <Button
            css={OfferDetailBrandButtonStyle}
            iconLeft={ConstructionHelmetIcon}
            variant="brand_icon"
            size={isMobile ? "medium" : "big"}
            onClick={() => {
                props.onButtonClick();
            }}
        >
            Zdjęcia z budowy
        </Button>
    );
};
import React from "react";

import {Button} from "@pg-design/button-module";
import {ConstructionHelmetIcon} from "@pg-design/icons-module";
import {useUserDevice} from "@pg-mono/user-device";

import {OfferDetailBrandButtonStyle} from "../atoms/OfferNavBar";

interface Props {
    onButtonClick: () => void;
}

export const DetailConstructionGalleryCTA = (props: Props) => {
    const {isMobile} = useUserDevice();
    return (
        <Button
            css={OfferDetailBrandButtonStyle}
            iconLeft={ConstructionHelmetIcon}
            variant="brand_icon"
            size={isMobile ? "medium" : "big"}
            onClick={() => {
                props.onButtonClick();
            }}
        >
            Zdjęcia z budowy
        </Button>
    );
};
